import MainPage from './pages/MainPage';

/**
 * Wurzel des Programm-Frontends. Der Dateiname `App.tsx` ist Pflicht: Der Core
 * sucht die Programm-Frontends per Glob (core/frontend/src/services/programmeLoader.ts).
 * Kein Router — Phase 1 hat genau eine Seite.
 */
export default function App() {
  return <MainPage />;
}
